/**
 * Mando Settings
 */

const settings = {
  arrowNext: `<div class="c-hero__carousel-action c-hero__carousel-action--next">
                <button class="c-button" type="button">
                <svg class="c-button__icon c-button__icon--right" aria-hidden="true" focusable="false">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-right"></use>
                </svg>
                  <span class="visually-hidden">Next slide</span>
                </button>
              </div>`,
  arrowPrev: `<div class="c-hero__carousel-action c-hero__carousel-action--prev">
                <button class="c-button" type="button">
                <svg class="c-button__icon c-button__icon--left" aria-hidden="true" focusable="false">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-left"></use>
                </svg>
                <span class="visually-hidden">Previous slide</span>
                </button>
              </div>`,
};

export default settings;



// WEBPACK FOOTER //
// ./src/scripts/settings-carousel.js